import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Nightjar theme preferences
const THEME_KEY = "nightjar_theme";

function getStoredTheme() {
  const stored = localStorage.getItem(THEME_KEY);

  return ["light", "dark", "system"].includes(stored)
    ? stored
    : "system";
}

function applyTheme() {
  const preference = getStoredTheme();

  const systemDark = window.matchMedia(
    "(prefers-color-scheme: dark)"
  ).matches;

  const resolvedTheme =
    preference === "system"
      ? systemDark
        ? "dark"
        : "light"
      : preference;

  document.documentElement.setAttribute(
    "data-theme",
    resolvedTheme
  );

  document.documentElement.classList.toggle(
    "dark",
    resolvedTheme === "dark"
  );
}

applyTheme();

// Automatically respond to system theme changes
window
  .matchMedia("(prefers-color-scheme: dark)")
  .addEventListener("change", applyTheme);

// Synchronise theme changes between browser tabs
window.addEventListener("storage", (event) => {
  if (event.key === THEME_KEY) {
    applyTheme();
  }
});

// Allow Nightjar components to change the theme
window.setNightjarTheme = function (theme) {
  if (!["light", "dark", "system"].includes(theme)) return;

  localStorage.setItem(THEME_KEY, theme);
  applyTheme();
  window.dispatchEvent(new Event("nightjar-theme-change"));
};

const root = ReactDOM.createRoot(
  document.getElementById("root")
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);